import React, { useEffect } from 'react';
import CuiButton from '../CuiComponents/Button';
import CuiIcon from '../CuiComponents/Icon';
import FocusTrap from 'focus-trap-react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { navigate } from '../../redux/actions/CourseActions';
import { removeBookmark } from '../../redux/actions/BookmarksActions';
import { useTranslation } from 'react-i18next';
import useXapi from '../../Hooks/useXapi';
import { actionsToHideModal } from '../../redux/actions/AppHeaderModalActions';
import { pseudolocalize } from '../Block/common/pseudolocalize/pseudolocalize';
import './Bookmarks.scss';

const Bookmarks = () => {
  const { xApiEvent } = useXapi();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { bookmarks, learningPathJson, courseId, isPseudo } = useSelector(
    state => ({
      bookmarks: state.BookmarksState.bookmarks,
      learningPathJson: state.CourseState.learningPathJson,
      courseId: state.CourseState.courseId,
      isPseudo: state.LanguageState.isPseudo
    }),
    shallowEqual
  );

  const courseBookmarks = bookmarks[courseId];

  const bodyEle = document.getElementsByTagName('body')[0];
  // prevent background scrolling while the bookmarks modal is visible
  useEffect(() => {
    bodyEle.style.cssText =
      'overflow: hidden; height: auto; padding-right: 15px;';
    return function cleanup() {
      bodyEle.style.cssText = '';
    };
  });

  return (
    <FocusTrap>
      <div className="bookmarks-outer">
        <div className="row bookmarks-header-stuck">
          <div className="col-sm-12">
            <div>
              <div className="icon-circle-wrap">
                <CuiIcon icon="bookmark" size="medium" />
              </div>
              <h1>{t('Bookmarks.bookmarks')}</h1>
            </div>
            <CuiButton
              id="close-btn"
              icon="close"
              onClick={() => {
                xApiEvent('Bookmarks Modal Closed', window.location.href);
                dispatch(actionsToHideModal('HIDE_BOOKMARKS'));
              }}
            />
          </div>
        </div>
        <div className="bookmarks-container">
          {courseBookmarks &&
            Object.keys(courseBookmarks.structure).map(modli => {
              let mod = learningPathJson.hasPart.find(m => m.li === modli);
              return (
                <div key={modli} className="row module-container">
                  <div className="col-sm-12">
                    <h3 className="module-title">{`${mod.li} ${
                      isPseudo ? pseudolocalize(mod.name) : mod.name
                    }`}</h3>
                    <ul className="module-bookmarks">
                      {Object.keys(courseBookmarks.structure[modli]).map(
                        bli => {
                          let block = mod.hasPart.find(
                            b => b.li === `${modli}.${bli}`
                          );
                          return (
                            <li key={bli} className="bookmark-item">
                              <CuiIcon icon="bookmark" size="small" />
                              <a
                                onClick={e => {
                                  e.preventDefault();
                                  dispatch(navigate(block));
                                }}
                                href={`#${block.li}`}
                              >
                                {`${block.li} ${
                                  isPseudo
                                    ? pseudolocalize(block.name)
                                    : block.name
                                }`}
                              </a>
                              <ul className="chunk-list">
                                {block.chunks
                                  .filter(
                                    c =>
                                      courseBookmarks.structure[modli][bli] &&
                                      courseBookmarks.structure[modli][
                                        bli
                                      ].includes(c.li)
                                  )
                                  .map((chunk, ci) => {
                                    return (
                                      <li key={ci} className="chunk-list-item">
                                        <a
                                          onClick={e => {
                                            e.preventDefault();
                                            dispatch(navigate(chunk));
                                          }}
                                          href={`#${chunk.li}`}
                                        >
                                          {`${chunk.li} ${
                                            isPseudo
                                              ? pseudolocalize(chunk.name)
                                              : chunk.name
                                          }`}
                                        </a>
                                        <button
                                          className="remove-bookmark"
                                          title={t('Bookmarks.removeBookmark')}
                                          onClick={() =>
                                            dispatch(removeBookmark(chunk.li))
                                          }
                                        >
                                          <CuiIcon icon="exit" />
                                        </button>
                                      </li>
                                    );
                                  })}
                              </ul>
                            </li>
                          );
                        }
                      )}
                    </ul>
                  </div>
                </div>
              );
            })}
          {(!courseBookmarks ||
            Object.keys(courseBookmarks.structure).length === 0) && (
            <div>{t('Bookmarks.noBookmarks')}</div>
          )}
        </div>
      </div>
    </FocusTrap>
  );
};
export default Bookmarks;
